import React from 'react';
import { Link } from 'react-router-dom';
import { Clock } from 'lucide-react';
import { BLOG_POSTS } from '../mock';
import Reveal from './Reveal';

const STOP = new Set(['flower', 'flowers', 'delivery', 'same', 'day', 'local', 'florist', 'ca', 'the', 'and', 'for', 'guide', 'best', 'a', 'to', 'in']);

const tokens = (p) => new Set(`${p.title} ${p.keywords}`.toLowerCase().split(/[^a-z0-9]+/).filter((w) => w.length > 2 && !STOP.has(w)));

export const RelatedPosts = ({ currentSlug }) => {
  const current = BLOG_POSTS.find((p) => p.slug === currentSlug);
  if (!current) return null;
  const cur = tokens(current);
  const related = BLOG_POSTS
    .filter((p) => p.slug !== currentSlug)
    .map((p) => {
      let score = 0;
      tokens(p).forEach((w) => { if (cur.has(w)) score += 1; });
      return { post: p, score };
    })
    .sort((a, b) => b.score - a.score)
    .slice(0, 3)
    .map((r) => r.post);
  if (!related.length) return null;

  return (
    <Reveal>
      <div data-testid="related-posts" className="mt-12">
        <h2 className="font-serif-display text-[26px] text-[#26302a] mb-6">You might also like</h2>
        <div className="grid sm:grid-cols-3 gap-5">
          {related.map((p) => (
            <Link key={p.slug} to={`/blog/${p.slug}`} data-testid={`related-post-${p.slug}`} className="group block rounded-2xl overflow-hidden border border-[#EAE2D6] bg-white hover:border-[#3D5142] transition-colors">
              <div className="h-36 overflow-hidden">
                <img src={p.heroImg} alt={p.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-4">
                <h3 className="text-[15px] font-semibold text-[#26302a] leading-snug group-hover:text-[#C4715A] transition-colors line-clamp-2">{p.title}</h3>
                <p className="mt-2 text-[13px] text-[#5A554C] flex items-center gap-1.5"><Clock className="w-3.5 h-3.5 text-[#C4715A]" /> {p.readTime}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </Reveal>
  );
};

export default RelatedPosts;
